import { Product } from 'common/types/entities/api/product'
import { StateKey } from 'common/utils/flipState'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export interface CoordiState {
  products: Product[]
  selectedId: string
}

const initializeState: CoordiState = {
  products: [],
  selectedId: null,
}

const FETCH_COORDI = 'coordi/FETCH_COORDI_PRODUCTS'
const SET_PRODUCT = 'coordi/SET_PRODUCT'

export const fetchCoordi = (curState: StateKey, productIds: string[], headers?: any) => async dispatch => {
  const coordiProducts = await Promise.all(
    productIds.map(productId =>
      axios.get<Product>(`/v1/products/${productId}`, {
        ...getHeaders(headers),
      }),
    ),
  )

  const filteredCoordi = coordiProducts
    .filter(coordiProduct => coordiProduct && coordiProduct.data)
    .map(coordiProduct => coordiProduct.data)

  dispatch({
    curState,
    type: FETCH_COORDI,
    coordiProducts: filteredCoordi || [],
  })
}

export const setCoordiProduct = (curState: StateKey, id: number) => {
  return {
    curState,
    selectedId: id.toString(),
    type: SET_PRODUCT,
  }
}

const coordiReducer = (state = initializeState, action) => {
  switch (action.type) {
    case FETCH_COORDI:
      return {
        ...state,
        products: action.coordiProducts,
      }
    case SET_PRODUCT:
      return {
        ...state,
        selectedId: action.selectedId,
      }
    default:
      return state
  }
}

export default coordiReducer
